import React from 'react';

import { useTranslation } from 'react-i18next';

import Table from 'components/application/Table';
import TableCell from 'components/application/TableCell';

export default function SubcontractorsTable({ onRowClick, subcontractors }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <Table
      headers={
        <tr>
          <th className='tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTShared('company')}
          </th>
        </tr>
      }
      rows={subcontractors.map((subcon) => (
        <tr
          className='handshq__tr--clickable tw-h-[49px] hover:tw-bg-grey-025'
          key={subcon.id}
          onClick={(event) => onRowClick(event, subcon)}
        >
          <TableCell>
            <span className='truncated-text-container tw-text-m tw-font-medium tw-text-grey-900'>
              {subcon.attributes.name}
            </span>
          </TableCell>
        </tr>
      ))}
    />
  );
}
